import React from 'react';
import PropTypes from 'prop-types'
import { styled } from "../../utilities";
import { Brutus, BlockO } from '../../assets';
import modules from './avatar.module.scss';

const ResizedIcon = styled.img`
    width: ${props => props.$width};
    height: ${props => props.$height};
`
const Avatar = (props = {}) => {
    const { icon, marginRight, className, blockO, width, height, darkMode, ...rest } = props
    let as = icon ? icon : blockO ? (props = {}) => <BlockO darkMode={darkMode} {...props} /> : Brutus
    
    return  <ResizedIcon $width={width} $height={height} aria-hidden as={as} className={`${blockO ? '' : modules.avatar} ${marginRight ? modules.marginRight : ''} ${className}`.trim()} {...rest} />
}

Avatar.defaultProps = {
    blockO: false,
    width: '2rem',
    height: '2rem',
    marginRight: true,
    className: ''
}

Avatar.propTypes = {
    icon: PropTypes.func,
    style: PropTypes.object,
    marginRight: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default Avatar